<template>
  <form @submit.prevent="">
    <ZDialog :show="isVisible" :modalSize="modalSize">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ title }}
              </h4>
            </div>
            <div class="col-md-1">
              <a href="#" @click="close" class="custom-close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="profileWrapper">
          <user-profile ref="userProfile" :cameFrom="value !== null ? value.cameFrom : 0"
            :isAdd="value !== null ? value.isAdd : false" @saved="userSaved" />
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col-md-3">
            <button type="button" class="btn btn-outline-secondary" @click="sendChangePassword"
              v-if="value !== null ? !value.isAdd : true">Change Password</button>
          </div>
          <div class="col-md-7">
            <span title="firm id / user id / contact id">{{ ids }}</span>
          </div>
          <div class="col-md-2 custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button v-show="isSaved" class="btn btn-primary ms-1" @click="submit">Save</button>
          </div>
        </div>
      </template>
    </ZDialog>
  </form>
</template>
<script>
import { mapState } from 'pinia'
import { users } from '@/stores'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import UserProfile from '@/components/users/forms/user-profile.vue'
export default {
  name: 'user-profile-dialog',
  components: {
    ZDialog,
    UserProfile
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      modalSize: 'modal-xl'
    }
  },
  computed: {
    ...mapState(users, ['user']),
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    isSaved: {
      get() {
        let _is = false
        if (this.value !== undefined && this.value !== null) {
          if (!this.value.isAdd) {
            _is = true
          }
        }
        return _is
      },
      set() {
        this.$emit('send', {
          isUpdate: true,
          user: this.user.user,
          contact: this.user.contact,
          fullName: `${this.user.lastName}, ${this.user.firstName}`
        })
      }
    },
    title() {
      let _title = ''
      if (this.value !== undefined && this.value !== null) {
        if (this.value.isAdd) {
          if (this.value.data.name === '') {
            _title = 'Adding User'
          } else {
            _title = `Adding User to ${this.value.data.name}`
          }
        } else {
          if (this.value.firstName !== undefined) {
            _title = `User Profile for ${this.value.firstName} ${this.value.lastName}`
          } else {
            _title = `Editing User: ${this.value.data.fullName}`
          }
        }
      }
      return _title
    },
    ids() {
      let _ids = ''
      if (this.value !== undefined && this.value !== null) {
        if (this.value.isAdd) {
          _ids = ''
        } else {
          if (this.value.firstName !== undefined) {
            _ids = `${this.value.firm}/${this.value.user}/${this.value.contact}`
          } else {
            _ids = `${this.value.data.firm}/${this.value.data.user}/${this.value.data.contact}`
          }
        }
      }
      return _ids
    }
  },
  methods: {
    sendChangePassword() {
      let data = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        user: this.user.user,
        contact: this.user.contact,
        username: this.user.username
      }
      this.$emit('sendChangePassword', data)
    },
    close() {
      this.$emit('closing')
    },
    userSaved(saved) {
      this.isSaved = saved
    },
    async submit() {
      await this.$refs.userProfile.save()
      this.$emit('send', {
        isUpdate: false,
        user: null,
        contact: null,
        username: null,
        firstName: null,
        lastName: null
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}

.custom-textarea {
  height: 200px;
}

.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}

.custom-footer {
  width: 100%;
  display: inline-flex;
}

.custom-right-align {
  text-align: right;
}

.profileWrapper {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
